import React, { useState } from "react";
import "./update.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { IconButton } from "@mui/material";
import { fonctionType, requestType } from "../../../types/GlobalType";
import { accountService } from "../../../_services/accountServices";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller";
import toast, { LoaderIcon } from "react-hot-toast";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: fonctionType | undefined;
  dispatchReload: () => void;
}
const UpdateFonction = (props: Props) => {
  const [fonctionDesignation, setfonctionDesignation] = useState(
    props.data?.fonction_designation
  );

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const handleUpdateFonction = async () => {
    if (!fonctionDesignation?.toString().length) {
      setState({
        ...state,
        errorMessage: "Veuiller complétez la fonction",
      });
      return setTimeout(() => {
        setState({
          ...state,
          errorMessage: null,
        });
      }, 3000);
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    try {
      let data = { designation: fonctionDesignation };
      const response = await API_CONFIG.FONCTION.update(
        props.data?.fonction_id,
        data,
        token
      );
      if (response.data.status === 200) {
        toast.success("Mis à jour effectuée avec succes", { duration: 3000 });
        setfonctionDesignation("");
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  return (
    <div className="UpdateDomaine">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <SchoolOutlined className="ico" />
              <span>Modification</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}
          <div className="item">
            <label>{"Fonction (Poste)"}</label>
            <input
              placeholder="Ex: Directeur des études"
              type="text"
              value={fonctionDesignation}
              onChange={(e) => setfonctionDesignation(e.target.value)}
            />
          </div>
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>

          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={handleUpdateFonction}>Mettre à jour</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateFonction;
